const MiraLinkLogo = ({ size = 128 }) => {
  const dimension = typeof size === 'number' ? `${size}px` : size;

  return (
    <div
      className="rounded-3xl shadow-sm overflow-hidden"
      style={{ width: dimension, height: dimension }}
      role="img"
      aria-label="MiraLink"
    >
      <svg viewBox="0 0 128 128" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="miralink-bg" x1="16" y1="16" x2="112" y2="112" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#8B5CF6" />
            <stop offset="0.52" stopColor="#5865F2" />
            <stop offset="1" stopColor="#22D3EE" />
          </linearGradient>
          <linearGradient id="miralink-link" x1="31" y1="44" x2="99" y2="84" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#F8FAFC" />
            <stop offset="0.45" stopColor="#BDE7FF" />
            <stop offset="1" stopColor="#D9F99D" />
          </linearGradient>
          <filter id="miralink-shadow" x="-16" y="-16" width="160" height="160" colorInterpolationFilters="sRGB">
            <feDropShadow dx="0" dy="8" stdDeviation="8" floodColor="#312E81" floodOpacity="0.28" />
          </filter>
        </defs>

        <rect width="128" height="128" rx="30" fill="url(#miralink-bg)" />
        <g filter="url(#miralink-shadow)">
          <path
            d="M39 67c0-16 10-28 24-28 8 0 15 4 21 12l9 12c4 5 7 8 11 8 6 0 10-5 10-12s-4-12-10-12c-4 0-7 2-11 7l-41 48c-5 6-12 9-20 9-14 0-24-12-24-28s10-28 24-28c8 0 15 4 21 12l9 12c4 5 7 8 11 8 6 0 10-5 10-12"
            fill="none"
            stroke="url(#miralink-link)"
            strokeWidth="12"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="38" cy="83" r="7" fill="#D9F99D" />
          <circle cx="90" cy="45" r="7" fill="#D9F99D" />
          <circle cx="64" cy="64" r="5" fill="#FFFFFF" opacity="0.95" />
        </g>
      </svg>
    </div>
  );
};

export default MiraLinkLogo;
